import { useContext } from 'react';
import { Outlet } from 'react-router-dom';

import AuthContext from '../store/auth-context';
import AppContext from '../store/app-context';

import useLayoutServices from '../hooks/use-layout-services';

import Overlay from '../components/Overlay/Overlay';
import Loading from '../components/Overlay/Loading/Loading';
import Message from '../components/Overlay/Message/Message';
import Dialog from '../components/Overlay/Dialog/Dialog';
import Login from '../components/Overlay/Login/Login';
import Connectivity from '../components/Connectivity/Connectivity';

import './DashboardLayout.scss';

const DashboardLayout = () => {
    const appCtx = useContext(AppContext);
    const authCtx = useContext(AuthContext);

    useLayoutServices();

    const isAuthenticated = authCtx.isAuthenticated;

    return (
        <>
            <Overlay>
                <Loading />
                <Message />
                <Dialog />
                <Login />
            </Overlay>
            {isAuthenticated && appCtx.init && (
                <div className="dashboard-root">
                    <Outlet />
                </div>
            )}
            <Connectivity />
        </>
    );
};

export default DashboardLayout;

export async function dashboardLoader(data: { request: any; params: any }) {
    return data;
}
